module.exports = __webpack_public_path__ + "img/vegetable-cauliflower-190x100.91d9fa90.jpg";